export const productColors = {
    products: [
        {
            product_id: 2029227769918,
            product_title: 'Classic Modern Layette Cuddle Box™️ - Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 2029974585406,
            product_title: 'Motherlode Modern Layette Cuddle Box™️ - Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 4386043822142,
            product_title: 'Cuddles the Elephant_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 4386051686462,
            product_title: 'Cuddles the Lovey_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 4609969651774,
            product_title: 'The Preemie NICU Gown_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777054270,
            product_title: 'Zipper One-Piece_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777087038,
            product_title: 'Zipper One-Piece_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777185342,
            product_title: 'Zipper One-Piece_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727896002622,
            product_title: 'Zipper One-Piece_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777381950,
            product_title: 'Long Sleeve Lucky Bodysuit_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777480254,
            product_title: 'Long Sleeve Lucky Bodysuit_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777611326,
            product_title: 'Long Sleeve Lucky Bodysuit_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777545790,
            product_title: 'Long Sleeve Lucky Bodysuit_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6876777644094,
            product_title: 'Long Sleeve Lucky Bodysuit_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883575267390,
            product_title: 'Long Sleeve Jack + Jill Bodysuit_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883575955518,
            product_title: 'Long Sleeve Jack + Jill Bodysuit_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883576021054,
            product_title: 'Long Sleeve Jack + Jill Bodysuit_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883606691902,
            product_title: 'Top Knot Cap_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883607576638,
            product_title: 'Top Knot Cap_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883607642174,
            product_title: 'Top Knot Cap_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883607969854,
            product_title: 'Top Knot Cap_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883607871550,
            product_title: 'Top Knot Cap_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883608330302,
            product_title: 'Top Knot Cap_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883608395838,
            product_title: 'Top Knot Cap_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883609247806,
            product_title: 'Top Knot Cap_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883609280574,
            product_title: 'Top Knot Cap_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883609706558,
            product_title: 'Coming Home Blanket_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883610525758,
            product_title: 'Coming Home Blanket_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883610591294,
            product_title: 'Coming Home Blanket_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883610918974,
            product_title: 'Coming Home Blanket_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883611770942,
            product_title: 'Coming Home Blanket_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883612098622,
            product_title: 'The BASIC Groove Pants_Pink Heather',
            basic_colors: 'Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883612164158,
            product_title: 'The BASIC Groove Pants_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622003774,
            product_title: 'Hello Baby Top_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622102078,
            product_title: 'Hello Baby Top_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622036542,
            product_title: 'Hello Baby Top_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622134846,
            product_title: 'Hello Baby Top_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622167614,
            product_title: 'Hello Baby Top_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622233150,
            product_title: 'Hello Baby Top_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622298686,
            product_title: 'Hello Baby Pant_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622331454,
            product_title: 'Hello Baby Pant_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622396990,
            product_title: 'Hello Baby Pant_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622429758,
            product_title: 'Hello Baby Pant_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622560830,
            product_title: 'Hello Baby Pant_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622495294,
            product_title: 'Hello Baby Pant_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622659134,
            product_title: 'Long Sleeve Crewneck Tee_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622691902,
            product_title: 'Long Sleeve Crewneck Tee_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622724670,
            product_title: 'Long Sleeve Crewneck Tee_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622790206,
            product_title: 'Long Sleeve Crewneck Tee_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905622822974,
            product_title: 'Long Sleeve Crewneck Tee_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905623117886,
            product_title: 'Short Sleeve Crewneck Tee_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905623183422,
            product_title: 'Short Sleeve Crewneck Tee_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905623281726,
            product_title: 'Short Sleeve Crewneck Tee_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6905623773246,
            product_title: 'Short Sleeve Crewneck Tee_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 547512909886,
            product_title: 'Motherlode Modern Layette Cuddle Box™️ - Blue',
            basic_colors: 'Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 539916075070,
            product_title: 'Short Sleeve Oxford Shirt',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 559459598398,
            product_title: 'Motherlode Modern Layette Cuddle Box™️ - Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 1424779444286,
            product_title: 'Mini Modern Layette Cuddle Box™️ - Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 1424806215742,
            product_title: 'Mini Modern Layette Cuddle Box™️ - Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 1424813162558,
            product_title: 'Mini Modern Layette Cuddle Box™️ - Blue',
            basic_colors: 'Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 1424832659518,
            product_title: 'Classic Modern Layette Cuddle Box™️ - Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 1976123031614,
            product_title: "Baby's First Year Box - Pink",
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 1976128962622,
            product_title: "Baby's First Year Box - Blue",
            basic_colors: 'Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 1987235217470,
            product_title: "Baby's First Year Box - Grey",
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 1996554895422,
            product_title: 'Mini First Year Box - Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 1996558565438,
            product_title: 'Mini First Year Box - Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 1996563742782,
            product_title: 'Mini First Year Box - Blue',
            basic_colors: 'Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 6930957991998,
            product_title: 'BASIC Groove Pants_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6930958024766,
            product_title: 'BASIC Groove Pants_Pink Heather',
            basic_colors: 'Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6930958123070,
            product_title: 'BASIC Groove Pants_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937345425470,
            product_title: 'Smocked Bubble Romper_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937346539582,
            product_title: 'Organic Arms-Out Sleep Bag_Cream',
            basic_colors: 'Cream',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937346768958,
            product_title: 'Organic Arms-Out Sleep Bag_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937346801726,
            product_title: 'Organic Arms-Out Sleep Bag_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937346834494,
            product_title: 'Organic Arms-Out Sleep Bag_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937346867262,
            product_title: 'Organic Arms-Out Sleep Bag_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937132236862,
            product_title: 'Bicycle Shorts_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937132269630,
            product_title: 'Bicycle Shorts_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937132302398,
            product_title: 'Bicycle Shorts_Hot Pink',
            basic_colors: 'Hot Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937132466238,
            product_title: 'Bicycle Shorts_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937134530622,
            product_title: 'Classic Leggings_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937134563390,
            product_title: 'Classic Leggings_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937134661694,
            product_title: 'Classic Leggings_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937137774654,
            product_title: 'Ruffle Bloomers_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937137741886,
            product_title: 'Ruffle Bloomers_Hot Pink',
            basic_colors: 'Hot Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937137807422,
            product_title: 'Ruffle Bloomers_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937137938494,
            product_title: 'Ruffle Bloomers_Light Blue',
            basic_colors: 'Light Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937137905726,
            product_title: 'Ruffle Bloomers_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6937138561086,
            product_title: 'Short Sleeve Oxford Shirt_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941032874046,
            product_title: 'Lucky Baby Cardigan_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941032972350,
            product_title: 'Lucky Baby Cardigan_Cream',
            basic_colors: 'Cream',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941033005118,
            product_title: 'Lucky Baby Cardigan_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941033037886,
            product_title: 'Lucky Baby Cardigan_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941089759294,
            product_title: 'Hospital Cuddle Box™_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941090054206,
            product_title: 'Hospital Cuddle Box™_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941090185278,
            product_title: 'Hospital Cuddle Box_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941090021438,
            product_title: 'Hospital Cuddle Box™_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761897160766,
            product_title: 'Hospital Cuddle Box™_Grey Elephant on Grey',
            basic_colors: 'Grey Elephant on Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761897455678,
            product_title: 'Hospital Cuddle Box™_Pink Elephant on Pink',
            basic_colors: 'Pink Elephant on Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941091725374,
            product_title: 'Hospital Cuddle Box™ - Mini_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941092413502,
            product_title: 'Hospital Cuddle Box™ - Mini_Grey Cabana Stripe',
            basic_colors: 'Grey Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941092511806,
            product_title: 'Hospital Cuddle Box™ - Mini_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761846763582,
            product_title: 'Hospital Cuddle Box™ - Mini_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941093527614,
            product_title: 'Hospital Cuddle Box™ - Mini_Blue Cabana Stripe',
            basic_colors: 'Blue Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941093298238,
            product_title: 'Hospital Cuddle Box™ - Mini_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761846894654,
            product_title: 'Hospital Cuddle Box™ - Mini_Grey Elephant on Grey',
            basic_colors: 'Grey Elephant on Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761846992958,
            product_title: 'Hospital Cuddle Box™ - Mini_Pink Elephant on Pink',
            basic_colors: 'Pink Elephant on Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938657390654,
            product_title: 'Little Darling Knit Top + Bottom_Light Blue',
            basic_colors: 'Light Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938657423422,
            product_title: 'Little Darling Knit Top + Bottom_Pink',
            basic_colors: 'Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938657456190,
            product_title: 'Little Darling Knit Top + Bottom_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938703626302,
            product_title: 'Sweatpant Brooklyn Skinnies_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938703659070,
            product_title: 'Sweatpant Brooklyn Skinnies_Navy Heather',
            basic_colors: 'Navy Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938703724606,
            product_title: 'Sweatpant Brooklyn Skinnies_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938703790142,
            product_title: 'BASIC Sweatshorts_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938703757374,
            product_title: 'BASIC Sweatshorts_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938704150590,
            product_title: 'Track Pants_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938704183358,
            product_title: 'Track Pants_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938704216126,
            product_title: 'Track Pants_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6938704281662,
            product_title: 'Track Pants_Black Heather',
            basic_colors: 'Black Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6966172188734,
            product_title: 'Bicycle Shorts_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6966172287038,
            product_title: 'Bicycle Shorts_Red',
            basic_colors: 'Red',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941014261822,
            product_title: 'Zip-Up Hoodie_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941014294590,
            product_title: 'Zip-Up Hoodie_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6941014327358,
            product_title: 'Zip-Up Hoodie_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6987756044350,
            product_title: 'Classic Modern Layette Cuddle Box™️ - Blue',
            basic_colors: 'Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012636222,
            product_title: 'Organic First Washcloth_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012701758,
            product_title: 'Organic First Washcloth_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012800062,
            product_title: 'Organic First Washcloth_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012832830,
            product_title: 'Organic First Washcloth_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012931134,
            product_title: 'Organic Hooded Towel_Navy Cabana Stripe',
            basic_colors: 'Navy Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012898366,
            product_title: 'Organic Hooded Towel_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968012996670,
            product_title: 'Organic Hooded Towel_Pink Cabana Stripe',
            basic_colors: 'Pink Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968019222590,
            product_title: 'Bicycle Shorts_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968020238398,
            product_title: 'BASIC Groove Pants_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 6968020271166,
            product_title: 'BASIC Sweatshorts_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037317840958,
            product_title: 'Fleece Leggings_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037318332478,
            product_title: 'Sweater Booties_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037318529086,
            product_title: 'Fleece Leggings_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037361717310,
            product_title: 'Little Darling Knit Top + Bottom_Cream',
            basic_colors: 'Cream',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037361750078,
            product_title: 'Little Darling Knit Top + Bottom_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037362307134,
            product_title: 'Fleece Leggings_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037362405438,
            product_title: 'Fleece Leggings_Charcoal',
            basic_colors: 'Charcoal',
            trunk_sale_colors: '',
        },
        {
            product_id: 7037683630142,
            product_title: 'Snuggle Up Blanket_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7089017389118,
            product_title: 'Long Sleeve Oxford Shirt_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7118156791870,
            product_title: 'Hospital Cuddle Box™ - Deluxe_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7118155743294,
            product_title: 'Hospital Cuddle Box™ - Deluxe_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7118156955710,
            product_title: 'Hospital Cuddle Box™ - Deluxe_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7123605815358,
            product_title: 'Kimono Tie One-Piece_Rainbow Ombre Elephant',
            basic_colors: 'Rainbow Ombre Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7145271853118,
            product_title: 'BASIC Sweatshorts_Black Heather',
            basic_colors: 'Black Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7145551233086,
            product_title: 'Hospital Cuddle Box™ - Mini_Pink Cabana Stripe',
            basic_colors: 'Pink Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7145551364158,
            product_title: 'Hospital Cuddle Box™_Grey Cabana Stripe',
            basic_colors: 'Grey Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7145551396926,
            product_title: 'Hospital Cuddle Box™_Pink Cabana Stripe',
            basic_colors: 'Pink Cabana Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7147162402878,
            product_title: 'Short Sleeve Tulle Dress_Light Blue',
            basic_colors: 'Light Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 7147162435646,
            product_title: 'Short Sleeve Tulle Dress_Mint',
            basic_colors: 'Mint',
            trunk_sale_colors: '',
        },
        {
            product_id: 7147162533950,
            product_title: 'Short Sleeve Tulle Dress_Yellow',
            basic_colors: 'Yellow',
            trunk_sale_colors: '',
        },
        {
            product_id: 7147162501182,
            product_title: 'Short Sleeve Tulle Dress_Purple',
            basic_colors: 'Purple',
            trunk_sale_colors: '',
        },
        {
            product_id: 7123607060542,
            product_title: 'Top Knot Cap_Rainbow Ombre Elephant',
            basic_colors: 'Rainbow Ombre Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7765269545022,
            product_title: 'Hello Baby Set_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761895817278,
            product_title: 'Hello Baby Set_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761896144958,
            product_title: 'Hello Baby Set_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761896407102,
            product_title: 'Hello Baby Set_Light Pink Heather',
            basic_colors: 'Light Pink Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761896570942,
            product_title: 'Hello Baby Set_Light Blue Heather',
            basic_colors: 'Light Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7761896734782,
            product_title: 'Hello Baby Set_Navy Blue Heather',
            basic_colors: 'Navy Blue Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7756573704254,
            product_title: 'Snuggle Cuddle Box™_Grey Elephant',
            basic_colors: 'Grey Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7756573802558,
            product_title: 'Snuggle Cuddle Box™_Pink Elephant',
            basic_colors: 'Pink Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7756573605950,
            product_title: 'Snuggle Cuddle Box™_Navy Elephant',
            basic_colors: 'Navy Elephant',
            trunk_sale_colors: '',
        },
        {
            product_id: 7186121556030,
            product_title: 'Terry Bathrobe_White + Grey',
            basic_colors: 'White + Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7186121621566,
            product_title: 'Terry Bathrobe_White + Pink',
            basic_colors: 'White + Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 7186121588798,
            product_title: 'Terry Bathrobe_White + Navy',
            basic_colors: 'White + Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 7225535266878,
            product_title: 'Brushed Yarn Blanket_Charcoal',
            basic_colors: 'Charcoal',
            trunk_sale_colors: '',
        },
        {
            product_id: 7225535660094,
            product_title: 'Brushed Yarn Teddy Cardigan_Charcoal',
            basic_colors: 'Charcoal',
            trunk_sale_colors: '',
        },
        {
            product_id: 7225536675902,
            product_title: 'Snuggle Up Blanket_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 7225536970814,
            product_title: 'Snuggle Up Blanket_Navy',
            basic_colors: 'Navy',
            trunk_sale_colors: '',
        },
        {
            product_id: 7225537953854,
            product_title: 'Fleece Leggings_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 7380326088766,
            product_title: 'Short Sleeve Tulle Dress_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7380326252606,
            product_title: '3-Pack Organic Washcloths_Rubber Duckies',
            basic_colors: 'Rubber Duckies',
            trunk_sale_colors: '',
        },
        {
            product_id: 7380326285374,
            product_title: 'Organic Hooded Towel_Rubber Duckies',
            basic_colors: 'Rubber Duckies',
            trunk_sale_colors: '',
        },
        {
            product_id: 7655276544062,
            product_title: 'Collegiate Cardigan_Heather Grey',
            basic_colors: 'Heather Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 7702364848190,
            product_title: 'Short Sleeve Crewneck Tee_Black',
            basic_colors: 'Black',
            trunk_sale_colors: '',
        },
        {
            product_id: 7368002699326,
            product_title: 'Organic Long Sleeve Polo_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7706997719102,
            product_title: 'Classic Leggings_Red',
            basic_colors: 'Red',
            trunk_sale_colors: '',
        },
        {
            product_id: 6940977922110,
            product_title: '3-Pack Short Sleeve Bodysuits_Grey',
            basic_colors: 'Grey',
            trunk_sale_colors: '',
        },
        {
            product_id: 6940977987646,
            product_title: '3-Pack Short Sleeve Bodysuits_White',
            basic_colors: 'White',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894233150,
            product_title: '3-Pack Short Sleeve Bodysuits_Pink Hearts',
            basic_colors: 'Pink Hearts',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894659134,
            product_title: 'Kimono Tie One-Piece_Cream Heather',
            basic_colors: 'Cream Heather',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894691902,
            product_title: 'Kimono Tie One-Piece_Cream Heather French Stripe',
            basic_colors: 'Cream Heather French Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894724670,
            product_title: 'Kimono Tie One-Piece_Light Blue',
            basic_colors: 'Light Blue',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894757438,
            product_title: 'Kimono Tie One-Piece_Light Blue French Stripe',
            basic_colors: 'Light Blue French Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894790206,
            product_title: 'Kimono Tie One-Piece_Light Pink',
            basic_colors: 'Light Pink',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727894822974,
            product_title: 'Kimono Tie One-Piece_Light Pink Polka Dots',
            basic_colors: 'Light Pink Polka Dots',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727895085118,
            product_title: 'On the Go One-Piece_Cream Heather French Stripe',
            basic_colors: 'Cream Heather French Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727895117886,
            product_title: 'On the Go One-Piece_Light Blue French Stripe',
            basic_colors: 'Light Blue French Stripe',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727895150654,
            product_title: 'On the Go One-Piece_Light Pink Polka Dots',
            basic_colors: 'Light Pink Polka Dots',
            trunk_sale_colors: '',
        },
        {
            product_id: 7727895248958,
            product_title: 'On the Go One-Piece_Yellow Triangles',
            basic_colors: 'Yellow Triangles',
            trunk_sale_colors: '',
        },
        {
            product_id: 6883575005246,
            product_title: 'SALE - Long Sleeve Jack + Jill Bodysuit_Pink',
            basic_colors: '',
            trunk_sale_colors: 'Pink',
        },
        {
            product_id: 6878433574974,
            product_title: 'SALE - Kimono Tie One-Piece_Spring Squad',
            basic_colors: '',
            trunk_sale_colors: 'Spring Squad',
        },
        {
            product_id: 6883575300158,
            product_title: 'SALE - Long Sleeve Jack + Jill Bodysuit_Grey',
            basic_colors: '',
            trunk_sale_colors: 'Grey',
        },
        {
            product_id: 6883575889982,
            product_title: 'SALE - Long Sleeve Jack + Jill Bodysuit_Navy',
            basic_colors: '',
            trunk_sale_colors: 'Navy',
        },
        {
            product_id: 6883610558526,
            product_title: 'SALE - Coming Home Blanket_Grey Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Grey Elephant',
        },
        {
            product_id: 6883609739326,
            product_title: 'SALE - Coming Home Blanket_Pink Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Pink Cabana Stripe',
        },
        {
            product_id: 6883610624062,
            product_title: 'SALE - Coming Home Blanket_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6883610951742,
            product_title: 'SALE - Coming Home Blanket_Blue Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Blue Cabana Stripe',
        },
        {
            product_id: 6883611803710,
            product_title: 'SALE - Coming Home Blanket_Navy Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Navy Elephant',
        },
        {
            product_id: 6883611902014,
            product_title: 'SALE - Coming Home Blanket_Spring Squad',
            basic_colors: '',
            trunk_sale_colors: 'Spring Squad',
        },
        {
            product_id: 6883632807998,
            product_title: 'SALE - On the Go One-Piece_Grey Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Grey Elephant',
        },
        {
            product_id: 6883633430590,
            product_title: 'SALE - On the Go One-Piece_Navy Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Navy Elephant',
        },
        {
            product_id: 6883633496126,
            product_title: 'SALE - On the Go One-Piece_Pink Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Pink Elephant',
        },
        {
            product_id: 6905623937086,
            product_title: 'SALE - Short Sleeve Crewneck Tee_Grey Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Stripe',
        },
        {
            product_id: 6905623969854,
            product_title: 'SALE - Short Sleeve Crewneck Tee_Pink Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Pink Stripe',
        },
        {
            product_id: 6937131548734,
            product_title: 'SALE - Always Blanket_Pink Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Pink Cabana Stripe',
        },
        {
            product_id: 6937132007486,
            product_title: 'SALE - Always Blanket_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6937132040254,
            product_title: 'SALE - Always Blanket_Blue Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Blue Cabana Stripe',
        },
        {
            product_id: 6937132564542,
            product_title: 'SALE - Cotton Muslin Swaddle 3-Pack_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 6937345589310,
            product_title: 'SALE - Flowy Romper_Light Blue French Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue French Stripe',
        },
        {
            product_id: 6937439469630,
            product_title: 'SALE - One-Piece Baby Pajamas_Grey Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Classic Stripe',
        },
        {
            product_id: 6937439404094,
            product_title:
                'SALE - One-Piece Baby Pajamas_Baby Pink Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Baby Pink Classic Stripe',
        },
        {
            product_id: 6937439535166,
            product_title: 'SALE - One-Piece Baby Pajamas_Navy Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Navy Classic Stripe',
        },
        {
            product_id: 6937439699006,
            product_title:
                'SALE - Two-Piece Pajama Set_Baby Pink Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Baby Pink Classic Stripe',
        },
        {
            product_id: 6937439764542,
            product_title: 'SALE - Two-Piece Pajama Set_Grey Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Classic Stripe',
        },
        {
            product_id: 6937439797310,
            product_title: 'SALE - Two-Piece Pajama Set_Navy Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Navy Classic Stripe',
        },
        {
            product_id: 6937135251518,
            product_title: 'SALE - Old Sport Shorts_Pink',
            basic_colors: '',
            trunk_sale_colors: 'Pink',
        },
        {
            product_id: 6937135185982,
            product_title: 'SALE - Old Sport Shorts_Light Blue Seersucker',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue Seersucker',
        },
        {
            product_id: 6938704838718,
            product_title: 'SALE - Organic Everyday Twill Shorts_Grey',
            basic_colors: '',
            trunk_sale_colors: 'Grey',
        },
        {
            product_id: 6938705068094,
            product_title: 'SALE - Organic Crib Quilt_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6938705166398,
            product_title:
                'SALE - Organic Fitted Crib Sheet_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6941190684734,
            product_title: 'SALE - Classic Bib_Grey Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Grey Elephant',
        },
        {
            product_id: 6942108287038,
            product_title: 'SALE - Organic Baby Booties_Grey',
            basic_colors: '',
            trunk_sale_colors: 'Grey',
        },
        {
            product_id: 6956665339966,
            product_title: 'SALE - Sunshine Tank Top_White',
            basic_colors: '',
            trunk_sale_colors: 'White',
        },
        {
            product_id: 6966172549182,
            product_title: 'SALE - Capri Legging_Red',
            basic_colors: '',
            trunk_sale_colors: 'Red',
        },
        {
            product_id: 6966172614718,
            product_title: 'SALE - Capri Legging_Hot Pink',
            basic_colors: '',
            trunk_sale_colors: 'Hot Pink',
        },
        {
            product_id: 6968019386430,
            product_title:
                'SALE - Short Sleeve Henley Tee_Grey + White Classic Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey + White Classic Stripe',
        },
        {
            product_id: 6968019419198,
            product_title: 'SALE - Short Sleeve Henley Tee_Navy + White Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Navy + White Stripe',
        },
        {
            product_id: 6968019451966,
            product_title:
                'SALE - Short Sleeve Jack + Jill Bodysuit_Grey Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Grey Elephant',
        },
        {
            product_id: 6968019517502,
            product_title:
                'SALE - Short Sleeve Jack + Jill Bodysuit_Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue',
        },
        {
            product_id: 6968019615806,
            product_title: 'SALE - Short Sleeve Jack + Jill Bodysuit_Purple',
            basic_colors: '',
            trunk_sale_colors: 'Purple',
        },
        {
            product_id: 6968020009022,
            product_title: 'SALE - Sunshine Tank Top_Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue',
        },
        {
            product_id: 6968020074558,
            product_title: 'SALE - Sunshine Tank Top_Mint',
            basic_colors: '',
            trunk_sale_colors: 'Mint',
        },
        {
            product_id: 6968020107326,
            product_title: 'SALE - Sunshine Tank Top_Lilac',
            basic_colors: '',
            trunk_sale_colors: 'Lilac',
        },
        {
            product_id: 6968020303934,
            product_title: 'SALE - Track Pants_Light Blue Heather',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue Heather',
        },
        {
            product_id: 6968020402238,
            product_title: 'SALE - Zipper One-Piece_Mint',
            basic_colors: '',
            trunk_sale_colors: 'Mint',
        },
        {
            product_id: 7013407031358,
            product_title:
                'SALE - Adult Embroidered Crewneck Sweatshirt_Mickey Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Mickey Mouse',
        },
        {
            product_id: 7013407064126,
            product_title: 'SALE - Coming Home Blanket_Minnie Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Minnie Mouse',
        },
        {
            product_id: 7013407162430,
            product_title: 'SALE - On the Go One-Piece_Minnie Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Minnie Mouse',
        },
        {
            product_id: 6968012734526,
            product_title: 'SALE - Organic First Washcloth_Navy Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Navy Cabana Stripe',
        },
        {
            product_id: 6968012668990,
            product_title: 'SALE - Organic First Washcloth_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6968012767294,
            product_title: 'SALE - Organic First Washcloth_Pink Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Pink Cabana Stripe',
        },
        {
            product_id: 6968012865598,
            product_title: 'SALE - Organic Hooded Towel_Grey Cabana Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Grey Cabana Stripe',
        },
        {
            product_id: 6968013029438,
            product_title: 'SALE - Organic Hooded Towel_Pink Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Pink Elephant',
        },
        {
            product_id: 6968012963902,
            product_title: 'SALE - Organic Hooded Towel_Navy Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Navy Elephant',
        },
        {
            product_id: 6968015749182,
            product_title: 'SALE - Short Sleeve Crewneck Tee_Lobster Tales',
            basic_colors: '',
            trunk_sale_colors: 'Lobster Tales',
        },
        {
            product_id: 6968016404542,
            product_title:
                'SALE - Sporty Bodysuit_Light Blue + White French Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue + White French Stripe',
        },
        {
            product_id: 7037317873726,
            product_title: 'SALE - Snuggle Up Bunting_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7037318037566,
            product_title: 'SALE - Sherpa Teddy Cardigan_Grey',
            basic_colors: '',
            trunk_sale_colors: 'Grey',
        },
        {
            product_id: 7037318463550,
            product_title: 'SALE - Moto Romper_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7037361946686,
            product_title: 'SALE - Classic Bib_Pink Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Pink Elephant',
        },
        {
            product_id: 7037362012222,
            product_title: 'SALE - Classic Bib_Navy Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Navy Elephant',
        },
        {
            product_id: 7037362241598,
            product_title: 'SALE - Baby No Scratch Mittens_Cream',
            basic_colors: '',
            trunk_sale_colors: 'Cream',
        },
        {
            product_id: 7145271820350,
            product_title: 'SALE - BASIC Sweatshorts_Light Blue Heather',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue Heather',
        },
        {
            product_id: 7145272344638,
            product_title: 'SALE - On the Go One-Piece_Field Trip',
            basic_colors: '',
            trunk_sale_colors: 'Field Trip',
        },
        {
            product_id: 7136153108542,
            product_title: 'SALE - Short Sleeve Crewneck Tee_Daffodil Delight',
            basic_colors: '',
            trunk_sale_colors: 'Daffodil Delight',
        },
        {
            product_id: 7147162599486,
            product_title: 'SALE - Smocked Ruffle Dress_Pink + White Ombre',
            basic_colors: '',
            trunk_sale_colors: 'Pink + White Ombre',
        },
        {
            product_id: 7149837680702,
            product_title: 'SALE - Capri Legging_Navy',
            basic_colors: '',
            trunk_sale_colors: 'Navy',
        },
        {
            product_id: 7149837647934,
            product_title: 'SALE - Capri Legging_Black',
            basic_colors: '',
            trunk_sale_colors: 'Black',
        },
        {
            product_id: 7149838008382,
            product_title: 'SALE - Groove Pants_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7159967973438,
            product_title: 'SALE - Ribbed Bubble Bodysuit_Hot Pink',
            basic_colors: '',
            trunk_sale_colors: 'Hot Pink',
        },
        {
            product_id: 7159968006206,
            product_title: 'SALE - Ribbed Capri Leggings_Hot Pink',
            basic_colors: '',
            trunk_sale_colors: 'Hot Pink',
        },
        {
            product_id: 7159968038974,
            product_title: 'SALE - Ribbed Button-Down Dress_Hot Pink',
            basic_colors: '',
            trunk_sale_colors: 'Hot Pink',
        },
        {
            product_id: 7159968137278,
            product_title: 'SALE - Ribbed Bubble Bodysuit_Peach',
            basic_colors: '',
            trunk_sale_colors: 'Peach',
        },
        {
            product_id: 7159968202814,
            product_title: 'SALE - Ribbed Button Up Romper_Peach',
            basic_colors: '',
            trunk_sale_colors: 'Peach',
        },
        {
            product_id: 7159968301118,
            product_title: 'SALE - Ribbed Spaghetti Strap Dress_Peach',
            basic_colors: '',
            trunk_sale_colors: 'Peach',
        },
        {
            product_id: 7159968235582,
            product_title: 'SALE - Ribbed Capri Leggings_Peach',
            basic_colors: '',
            trunk_sale_colors: 'Peach',
        },
        {
            product_id: 7159970660414,
            product_title: 'SALE - Ribbed Bubble Bodysuit_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 7159970693182,
            product_title: 'SALE - Ribbed Spaghetti Strap Dress_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 7159970725950,
            product_title: 'SALE - Ribbed Capri Leggings_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 7149838106686,
            product_title: 'SALE - One-Piece Baby Footed Pajamas_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149838139454,
            product_title: 'SALE - One-Piece Baby Pajamas_Happy Birthday',
            basic_colors: '',
            trunk_sale_colors: 'Happy Birthday',
        },
        {
            product_id: 7149838336062,
            product_title: 'SALE - Organic Polo Romper_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149838467134,
            product_title: 'SALE - Organic Short Sleeve Polo_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839286334,
            product_title: 'SALE - Slub Shorty Romper_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839220798,
            product_title: 'SALE - Sleeveless Ruffle Bodysuit_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839417406,
            product_title: 'SALE - Summer Sporty Sweatpants_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839646782,
            product_title: 'SALE - Sweet Baby B Romper_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839679550,
            product_title: 'SALE - Top Knot Cap_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7149839843390,
            product_title: 'SALE - Two-Piece Pajama Set_Happy Birthday',
            basic_colors: '',
            trunk_sale_colors: 'Happy Birthday',
        },
        {
            product_id: 7159967449150,
            product_title: 'SALE - Ribbed Button Up Romper_Blue',
            basic_colors: '',
            trunk_sale_colors: 'Blue',
        },
        {
            product_id: 7159967416382,
            product_title: 'SALE - Ribbed Bubble Bodysuit_Blue',
            basic_colors: '',
            trunk_sale_colors: 'Blue',
        },
        {
            product_id: 7178439065662,
            product_title: 'SALE - BASIC Sweatshorts_Navy + White Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Navy + White Stripe',
        },
        {
            product_id: 7184650108990,
            product_title: 'SALE - Long Sleeve Crewneck Tee_Fall Apples',
            basic_colors: '',
            trunk_sale_colors: 'Fall Apples',
        },
        {
            product_id: 7159972495422,
            product_title: 'SALE - Racerback Shortall_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7193453559870,
            product_title: 'SALE - Organic Burp Cloth_Pink Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Pink Elephant',
        },
        {
            product_id: 7193453625406,
            product_title: 'SALE - Organic Burp Cloth_Navy Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Navy Elephant',
        },
        {
            product_id: 7193453592638,
            product_title: 'SALE - Organic Burp Cloth_Grey Elephant',
            basic_colors: '',
            trunk_sale_colors: 'Grey Elephant',
        },
        {
            product_id: 7225535332414,
            product_title: 'SALE - Brushed Yarn Sporty Sweatshirt_Charcoal',
            basic_colors: '',
            trunk_sale_colors: 'Charcoal',
        },
        {
            product_id: 7225535365182,
            product_title: 'SALE - Brushed Yarn Sporty Sweatpants_Charcoal',
            basic_colors: '',
            trunk_sale_colors: 'Charcoal',
        },
        {
            product_id: 7225535823934,
            product_title: 'SALE - Family Knit Throw Blanket_Cream',
            basic_colors: '',
            trunk_sale_colors: 'Cream',
        },
        {
            product_id: 7225537036350,
            product_title: 'SALE - Knit Oxford Shirt_Navy',
            basic_colors: '',
            trunk_sale_colors: 'Navy',
        },
        {
            product_id: 7225537560638,
            product_title: 'SALE - Ribbed Velour Sweatsuit_Black',
            basic_colors: '',
            trunk_sale_colors: 'Black',
        },
        {
            product_id: 7225537691710,
            product_title: 'SALE - Ribbed Velour Turtleneck_Black',
            basic_colors: '',
            trunk_sale_colors: 'Black',
        },
        {
            product_id: 7225537724478,
            product_title: 'SALE - Ribbed Velour Sweatsuit_Bright Pink',
            basic_colors: '',
            trunk_sale_colors: 'Bright Pink',
        },
        {
            product_id: 7225537790014,
            product_title: 'SALE - Ribbed Velour Turtleneck_Bright Pink',
            basic_colors: '',
            trunk_sale_colors: 'Bright Pink',
        },
        {
            product_id: 7236066279486,
            product_title: 'SALE - Perfect Peacoat_Green',
            basic_colors: '',
            trunk_sale_colors: 'Green',
        },
        {
            product_id: 7240019574846,
            product_title:
                "SALE - Sporty Sweatsuit Bundle_Disney's Frozen Olaf",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Olaf",
        },
        {
            product_id: 7236066607166,
            product_title: 'SALE - 8-Pack Classic Bibs_Holiday Multipack',
            basic_colors: '',
            trunk_sale_colors: 'Holiday Multipack',
        },
        {
            product_id: 7240018526270,
            product_title: "SALE - Bomber Jacket_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018559038,
            product_title: "SALE - Classic Leggings_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018591806,
            product_title: "SALE - Long Sleeve Peplum Tee_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018624574,
            product_title: "SALE - Double Ruffle Sweatshirt_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018755646,
            product_title: "SALE - Sporty Sweatshirt_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018722878,
            product_title: "SALE - Sporty Sweatpants_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240018853950,
            product_title:
                "SALE - Double Ruffle Let's Dance Dress_Disney's Frozen Anna",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Anna",
        },
        {
            product_id: 7240018886718,
            product_title:
                "SALE - Long Sleeve Tulle Dress_Disney's Frozen Anna",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Anna",
        },
        {
            product_id: 7240018919486,
            product_title:
                "SALE - Double Ruffle Let's Dance Dress_Disney's Frozen Elsa",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Elsa",
        },
        {
            product_id: 7240018952254,
            product_title:
                "SALE - Long Sleeve Tulle Dress_Disney's Frozen Elsa",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Elsa",
        },
        {
            product_id: 7240019083326,
            product_title: "SALE - Sporty Sweatpants_Disney's Frozen Olaf",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Olaf",
        },
        {
            product_id: 7240019017790,
            product_title:
                "SALE - Embroidered Crewneck Sweatshirt_Disney's Frozen Olaf",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Olaf",
        },
        {
            product_id: 7240019116094,
            product_title: "SALE - Sporty Sweatshirt_Disney's Frozen Olaf",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen Olaf",
        },
        {
            product_id: 7240019279934,
            product_title:
                "SALE - Let's Dance Dress Leggings Bundle_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240019443774,
            product_title: "SALE - Peplum Top Leggings Bundle_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7240019509310,
            product_title: "SALE - Sporty Sweatsuit Bundle_Disney's Frozen",
            basic_colors: '',
            trunk_sale_colors: "Disney's Frozen",
        },
        {
            product_id: 7268430151742,
            product_title: 'SALE - Always Blanket_Baby Penguins',
            basic_colors: '',
            trunk_sale_colors: 'Baby Penguins',
        },
        {
            product_id: 7268430184510,
            product_title: 'SALE - Apres Ski Romper_Pastel Stripes',
            basic_colors: '',
            trunk_sale_colors: 'Pastel Stripes',
        },
        {
            product_id: 7268431003710,
            product_title: 'SALE - Fleece Zipper One-Piece_Snowboarder',
            basic_colors: '',
            trunk_sale_colors: 'Snowboarder',
        },
        {
            product_id: 7268431102014,
            product_title: 'SALE - Groove Pants_Polar Bear Party',
            basic_colors: '',
            trunk_sale_colors: 'Polar Bear Party',
        },
        {
            product_id: 7268433887294,
            product_title: 'SALE - Top Knot Cap_Polar Bear Party',
            basic_colors: '',
            trunk_sale_colors: 'Polar Bear Party',
        },
        {
            product_id: 7281044652094,
            product_title: "SALE - 7-Pack Boy's Briefs_Blues",
            basic_colors: '',
            trunk_sale_colors: 'Blues',
        },
        {
            product_id: 7281045274686,
            product_title: 'SALE - Knit Ruffle Sweater_Pastel Stripes',
            basic_colors: '',
            trunk_sale_colors: 'Pastel Stripes',
        },
        {
            product_id: 7281045897278,
            product_title: 'SALE - Top Knot Cap_Red Hearts on Pink',
            basic_colors: '',
            trunk_sale_colors: 'Red Hearts on Pink',
        },
        {
            product_id: 7281045995582,
            product_title:
                'SALE - Printed Organic Lounge Robe_Red Hearts on Pink',
            basic_colors: '',
            trunk_sale_colors: 'Red Hearts on Pink',
        },
        {
            product_id: 7281045962814,
            product_title: 'SALE - Organic Lounge Pant_Red Hearts on Pink',
            basic_colors: '',
            trunk_sale_colors: 'Red Hearts on Pink',
        },
        {
            product_id: 7281046061118,
            product_title: 'SALE - Organic Lounge Top_Red Hearts on Pink',
            basic_colors: '',
            trunk_sale_colors: 'Red Hearts on Pink',
        },
        {
            product_id: 7314815746110,
            product_title:
                'SALE - Adult Printed Crewneck Sweatshirt_Disney Princess Checkerboard',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess Checkerboard',
        },
        {
            product_id: 7314815778878,
            product_title: 'SALE - Classic Leggings_Light Pink',
            basic_colors: '',
            trunk_sale_colors: 'Light Pink',
        },
        {
            product_id: 7314815811646,
            product_title: 'SALE - Classic Leggings_Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue',
        },
        {
            product_id: 7314815877182,
            product_title: 'SALE - Classic Leggings_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 7314816630846,
            product_title:
                'SALE - Short Sleeve Dress Bodysuit_Disney Princess on Light Pink',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess on Light Pink',
        },
        {
            product_id: 7314816696382,
            product_title:
                'SALE - Sporty Sweatpants_Disney Princess Checkerboard',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess Checkerboard',
        },
        {
            product_id: 7314816729150,
            product_title:
                'SALE - Sporty Sweatshirt_Disney Princess Checkerboard',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess Checkerboard',
        },
        {
            product_id: 7314816761918,
            product_title:
                'SALE - Sporty Sweatsuit Bundle_Disney Princess Checkerboard',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess Checkerboard',
        },
        {
            product_id: 7362881159230,
            product_title:
                "SALE - 7-Pack Boy's Briefs_Cars on Charcoal Checkerboard",
            basic_colors: '',
            trunk_sale_colors: 'Cars on Charcoal Checkerboard',
        },
        {
            product_id: 7362881290302,
            product_title:
                'SALE - Long Sleeve Crewneck Tee_Lightning McQueen on White',
            basic_colors: '',
            trunk_sale_colors: 'Lightning McQueen on White',
        },
        {
            product_id: 7362881323070,
            product_title:
                "SALE - Long Sleeve Let's Dance Dress_Lightning McQueen on White",
            basic_colors: '',
            trunk_sale_colors: 'Lightning McQueen on White',
        },
        {
            product_id: 7362881749054,
            product_title:
                'SALE - Sporty Sweatshirt_Lightning McQueen on White',
            basic_colors: '',
            trunk_sale_colors: 'Lightning McQueen on White',
        },
        {
            product_id: 7362981134398,
            product_title: 'SALE - Classic Leggings_Disney Princess Mint',
            basic_colors: '',
            trunk_sale_colors: 'Disney Princess Mint',
        },
        {
            product_id: 7368002895934,
            product_title: 'SALE - Cargo Sweatpants_Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue',
        },
        {
            product_id: 7368003125310,
            product_title: 'SALE - Smocked Bubble Romper_Light Blue Seersucker',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue Seersucker',
        },
        {
            product_id: 7368003289150,
            product_title: 'SALE - Always Blanket_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7368003387454,
            product_title: 'SALE - Organic Burp Cloth_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7380328087614,
            product_title: 'SALE - Smocked Sundress_Sunnies Day',
            basic_colors: '',
            trunk_sale_colors: 'Sunnies Day',
        },
        {
            product_id: 7380328120382,
            product_title: 'SALE - Sporty Sweatpants_Tulips on Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Tulips on Light Blue',
        },
        {
            product_id: 7380328185918,
            product_title: 'SALE - Cargo Sweatpants_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7380328218686,
            product_title: 'SALE - Classic Leggings_Royal Blue',
            basic_colors: '',
            trunk_sale_colors: 'Royal Blue',
        },
        {
            product_id: 7380328251454,
            product_title: 'SALE - Classic Leggings_Fresh Florals',
            basic_colors: '',
            trunk_sale_colors: 'Fresh Florals',
        },
        {
            product_id: 7380328349758,
            product_title: 'SALE - BASIC Sweatshorts_Llama Love',
            basic_colors: '',
            trunk_sale_colors: 'Llama Love',
        },
        {
            product_id: 7380328513598,
            product_title:
                'SALE - Adult Sporty Sweatshirt_Tulips on Light Blue',
            basic_colors: '',
            trunk_sale_colors: 'Tulips on Light Blue',
        },
        {
            product_id: 7380328644670,
            product_title: 'SALE - Coming Home Blanket_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7380328710206,
            product_title: 'SALE - Coming Home Blanket_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7380328742974,
            product_title: 'SALE - Top Knot Cap_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7380328808510,
            product_title: 'SALE - Top Knot Cap_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7380328906814,
            product_title: 'SALE - Classic Bib_Suns Out',
            basic_colors: '',
            trunk_sale_colors: 'Suns Out',
        },
        {
            product_id: 7380328939582,
            product_title: 'SALE - Classic Bib_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7380329234494,
            product_title:
                'SALE - Seersucker Dress_Watermelon on Pink + Green Seersucker',
            basic_colors: '',
            trunk_sale_colors: 'Watermelon on Pink + Green Seersucker',
        },
        {
            product_id: 7380329300030,
            product_title: "SALE - 7-Pack Boy's Briefs_Spring Multipack",
            basic_colors: '',
            trunk_sale_colors: 'Spring Multipack',
        },
        {
            product_id: 7380329398334,
            product_title:
                'SALE - Hospital Cuddle Box™  - Mini_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7380326023230,
            product_title: 'SALE - Rain Jacket_Yellow',
            basic_colors: '',
            trunk_sale_colors: 'Yellow',
        },
        {
            product_id: 7380326187070,
            product_title: 'SALE - Knit Cardigan Sweater_Cream',
            basic_colors: '',
            trunk_sale_colors: 'Cream',
        },
        {
            product_id: 7380326514750,
            product_title: 'SALE - Kimono Tie One-Piece_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7380327104574,
            product_title: 'SALE - Groove Pants_Airplane Adventure',
            basic_colors: '',
            trunk_sale_colors: 'Airplane Adventure',
        },
        {
            product_id: 7520209207358,
            product_title: 'SALE - On The Go One-Piece_Summer Mickey Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Summer Mickey Mouse',
        },
        {
            product_id: 7520209338430,
            product_title: 'SALE - Oversized Slouchy Tee_Summer Mickey Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Summer Mickey Mouse',
        },
        {
            product_id: 7520209371198,
            product_title: 'SALE - Oversized Slouchy Tee_Summer Minnie Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Summer Minnie Mouse',
        },
        {
            product_id: 7520209403966,
            product_title:
                'SALE - Sporty Sweatsuit Bundle_Summer Mickey + Minnie',
            basic_colors: '',
            trunk_sale_colors: 'Summer Mickey + Minnie',
        },
        {
            product_id: 7520209469502,
            product_title: 'SALE - Two-Piece Pajama Set_Summer Mickey Mouse',
            basic_colors: '',
            trunk_sale_colors: 'Summer Mickey Mouse',
        },
        {
            product_id: 7530307256382,
            product_title: 'SALE - Racerback Peplum Tank_Berry Season',
            basic_colors: '',
            trunk_sale_colors: 'Berry Season',
        },
        {
            product_id: 7530307420222,
            product_title: 'SALE - Shorty Bubble Romper_Berry Season',
            basic_colors: '',
            trunk_sale_colors: 'Berry Season',
        },
        {
            product_id: 7530307452990,
            product_title: 'SALE - Sleeveless Ruffle Bodysuit_Berry Season',
            basic_colors: '',
            trunk_sale_colors: 'Berry Season',
        },
        {
            product_id: 7543793287230,
            product_title: 'SALE - Cargo Shorts_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7543793319998,
            product_title: 'SALE - Cargo Shorts_Navy Heather',
            basic_colors: '',
            trunk_sale_colors: 'Navy Heather',
        },
        {
            product_id: 7543794466878,
            product_title: 'SALE - Short Sleeve Crewneck Tee_Summer Sail',
            basic_colors: '',
            trunk_sale_colors: 'Summer Sail',
        },
        {
            product_id: 7582570872894,
            product_title: 'SALE - Sporty Sweatsuit Bundle_Barbie™ Essentials',
            basic_colors: '',
            trunk_sale_colors: 'Barbie™ Essentials',
        },
        {
            product_id: 7582570807358,
            product_title:
                "SALE - Short Sleeve Let's Dance Dress_Barbie™ Stripe",
            basic_colors: '',
            trunk_sale_colors: 'Barbie™ Stripe',
        },
        {
            product_id: 7643966472254,
            product_title: 'SALE - 3-Pack Romper Bundle_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643966505022,
            product_title: 'SALE - 3-Piece Take Me Home Set_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643966570558,
            product_title: 'SALE - 3-Pack Romper Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643966636094,
            product_title:
                'SALE - 5-Pack Long Sleeve Bodysuit Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643966668862,
            product_title:
                'SALE - 5-Pack Long Sleeve Bodysuit Bundle_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643966701630,
            product_title: 'SALE - Always Blanket_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643966734398,
            product_title:
                'SALE - 5-Pack Long Sleeve Bodysuit Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643966767166,
            product_title: 'SALE - Always Blanket_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643966832702,
            product_title: 'SALE - Classic Bib_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643966799934,
            product_title: 'SALE - Baby Headband_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643966865470,
            product_title: 'SALE - Classic Bib_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643966931006,
            product_title: 'SALE - Coming Home Blanket_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643966963774,
            product_title: 'SALE - Double Ruffle Romper_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643967062078,
            product_title: 'SALE - Essential Baby Zipper Bundle_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643967094846,
            product_title: 'SALE - Essential Baby Zipper Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643967127614,
            product_title: 'SALE - Essential Baby Zipper Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643967160382,
            product_title: 'SALE - Fleece Zipper One-Piece_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643967193150,
            product_title: 'SALE - Fleece Zipper One-Piece_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643967258686,
            product_title: 'SALE - Fleece Zipper One-Piece_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643967291454,
            product_title: 'SALE - Groove Pants_Light Blue Heather',
            basic_colors: '',
            trunk_sale_colors: 'Light Blue Heather',
        },
        {
            product_id: 7643967324222,
            product_title: 'SALE - Groove Pants_Light Pink Heather',
            basic_colors: '',
            trunk_sale_colors: 'Light Pink Heather',
        },
        {
            product_id: 7643967389758,
            product_title: 'SALE - Groove Pants_Light Yellow Heather',
            basic_colors: '',
            trunk_sale_colors: 'Light Yellow Heather',
        },
        {
            product_id: 7643967422526,
            product_title: 'SALE - Henley Romper_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643967586366,
            product_title: 'SALE - Hospital Cuddle Box™  - Mini_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643967782974,
            product_title:
                'SALE - Jack + Jill Bodysuit Groove Pants Bundle_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643967815742,
            product_title:
                'SALE - Jack + Jill Bodysuit Groove Pants Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643967848510,
            product_title:
                'SALE - Jack + Jill Bodysuit Groove Pants Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643967946814,
            product_title:
                "SALE - Let's Dance Dress Leggings Bundle_Pink Unicorns",
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643967979582,
            product_title: 'SALE - Long Sleeve Crewneck Tee_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968045118,
            product_title:
                'SALE - Long Sleeve Jack + Jill Bodysuit_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643968077886,
            product_title:
                'SALE - Long Sleeve Jack + Jill Bodysuit_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968143422,
            product_title: 'SALE - Long Sleeve Peplum Tee_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968176190,
            product_title: "SALE - Long Sleeve Let's Dance Dress_Pink Unicorns",
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643968208958,
            product_title: 'SALE - Long Sleeve Peplum Tee_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643968241726,
            product_title:
                'SALE - Long Sleeve Polo Corduroy Pant Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968340030,
            product_title: 'SALE - On The Go One-Piece_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968471102,
            product_title: 'SALE - Organic Burp Cloth_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643968536638,
            product_title: 'SALE - Organic Burp Cloth_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968634942,
            product_title: 'SALE - Organic Burp Cloth_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643968569406,
            product_title: 'SALE - Organic Long Sleeve Polo_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968667710,
            product_title: 'SALE - Peplum Top Leggings Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643968700478,
            product_title:
                'SALE - Printed Tee Chino Jogger Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968733246,
            product_title:
                'SALE - Ruffle Sweatshirt Leggings Bundle_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643968766014,
            product_title: 'SALE - Soft Touch Gown_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968929854,
            product_title: 'SALE - Top Knot Cap_Blue Trains',
            basic_colors: '',
            trunk_sale_colors: 'Blue Trains',
        },
        {
            product_id: 7643968897086,
            product_title: 'SALE - Sporty Sweatsuit Bundle_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643968995390,
            product_title: 'SALE - Top Knot Cap_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643969060926,
            product_title: 'SALE - Two-Piece Pajama Set_Forest Friends',
            basic_colors: '',
            trunk_sale_colors: 'Forest Friends',
        },
        {
            product_id: 7643969323070,
            product_title: "SALE - Double Ruffle Let's Dance Dress_Giddy Up",
            basic_colors: '',
            trunk_sale_colors: 'Giddy Up',
        },
        {
            product_id: 7643969388606,
            product_title: 'SALE - Elastic Waist Cargo Pants_Khaki',
            basic_colors: '',
            trunk_sale_colors: 'Khaki',
        },
        {
            product_id: 7643969617982,
            product_title: 'SALE - Flare Two-Piece Set_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643969716286,
            product_title: 'SALE - Hospital Cuddle Box™  - Mini_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643969814590,
            product_title: 'SALE - Knit Overalls_Guitars',
            basic_colors: '',
            trunk_sale_colors: 'Guitars',
        },
        {
            product_id: 7643970043966,
            product_title: 'SALE - Long Sleeve Crewneck Tee_Giddy Up',
            basic_colors: '',
            trunk_sale_colors: 'Giddy Up',
        },
        {
            product_id: 7643970502718,
            product_title: 'SALE - Peplum Top Leggings Bundle_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643970666558,
            product_title: 'SALE - Quilted Jacket_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7643970732094,
            product_title: 'SALE - Quilted Sporty Sweatpants_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7643970764862,
            product_title: 'SALE - Quilted Sporty Sweatshirt_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7643970830398,
            product_title: 'SALE - Quilted Romper_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7643970928702,
            product_title: 'SALE - Rugby Polo Dress_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643971059774,
            product_title: 'SALE - Rugby Romper_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643970994238,
            product_title: 'SALE - Rugby Polo_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643971092542,
            product_title: 'SALE - Sporty Sweatsuit Bundle_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643971158078,
            product_title: 'SALE - Top Knot Cap_Happy Dinos',
            basic_colors: '',
            trunk_sale_colors: 'Happy Dinos',
        },
        {
            product_id: 7643971289150,
            product_title: 'SALE - Zip Bomber Jacket_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7643971485758,
            product_title: 'SALE - Moto Romper_Football Fun',
            basic_colors: '',
            trunk_sale_colors: 'Football Fun',
        },
        {
            product_id: 7643971420222,
            product_title: "SALE - Long Sleeve Let's Dance Dress_Football Fun",
            basic_colors: '',
            trunk_sale_colors: 'Football Fun',
        },
        {
            product_id: 7643971518526,
            product_title: 'SALE - Sporty Sweatpants_Football Fun',
            basic_colors: '',
            trunk_sale_colors: 'Football Fun',
        },
        {
            product_id: 7643971551294,
            product_title: 'SALE - Sporty Sweatshirt_Football Fun',
            basic_colors: '',
            trunk_sale_colors: 'Football Fun',
        },
        {
            product_id: 7649412743230,
            product_title: 'SALE - Always Blanket_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7649412808766,
            product_title: 'SALE - Classic Bib_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7649412874302,
            product_title: 'SALE - Top Knot Cap_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7649412841534,
            product_title:
                'SALE - Long Sleeve Jack + Jill Bodysuit_Pink Unicorns',
            basic_colors: '',
            trunk_sale_colors: 'Pink Unicorns',
        },
        {
            product_id: 7652264083518,
            product_title: 'SALE - Shirt Jacket_Beige Flannel',
            basic_colors: '',
            trunk_sale_colors: 'Beige Flannel',
        },
        {
            product_id: 7704867766334,
            product_title: 'SALE - 2 Pack Bodysuit Bundle_Oh, Donut Even',
            basic_colors: '',
            trunk_sale_colors: 'Oh, Donut Even',
        },
        {
            product_id: 7706997751870,
            product_title:
                "SALE - Double Ruffle Let's Dance Dress_I Heart Dalmatians",
            basic_colors: '',
            trunk_sale_colors: 'I Heart Dalmatians',
        },
        {
            product_id: 7706997784638,
            product_title:
                "SALE - Double Ruffle Let's Dance Dress_Disney Valentines",
            basic_colors: '',
            trunk_sale_colors: 'Disney Valentines',
        },
        {
            product_id: 7706997882942,
            product_title: 'SALE - Jack + Jill Romper_Disney Valentines',
            basic_colors: '',
            trunk_sale_colors: 'Disney Valentines',
        },
        {
            product_id: 7706997817406,
            product_title: "SALE - Double Ruffle Let's Dance Dress_Pot of Gold",
            basic_colors: '',
            trunk_sale_colors: 'Pot of Gold',
        },
        {
            product_id: 7706997915710,
            product_title: 'SALE - Jack + Jill Romper_I Heart Dalmatians',
            basic_colors: '',
            trunk_sale_colors: 'I Heart Dalmatians',
        },
        {
            product_id: 7706997948478,
            product_title: 'SALE - Jack + Jill Romper_Pot of Gold',
            basic_colors: '',
            trunk_sale_colors: 'Pot of Gold',
        },
        {
            product_id: 7706997981246,
            product_title: 'SALE - Long Sleeve Crewneck Tee_Disney Valentines',
            basic_colors: '',
            trunk_sale_colors: 'Disney Valentines',
        },
        {
            product_id: 7706998046782,
            product_title: 'SALE - Long Sleeve Crewneck Tee_Pot of Gold',
            basic_colors: '',
            trunk_sale_colors: 'Pot of Gold',
        },
        {
            product_id: 7706998079550,
            product_title:
                'SALE - Long Sleeve Tee + Sweatpant Set_I Heart Dalmatians',
            basic_colors: '',
            trunk_sale_colors: 'I Heart Dalmatians',
        },
        {
            product_id: 7706998145086,
            product_title: 'SALE - Organic Lounge Pant_Tiny Hearts',
            basic_colors: '',
            trunk_sale_colors: 'Tiny Hearts',
        },
        {
            product_id: 7706998177854,
            product_title: 'SALE - Organic Lounge Top_Tiny Hearts',
            basic_colors: '',
            trunk_sale_colors: 'Tiny Hearts',
        },
        {
            product_id: 7739223474238,
            product_title:
                'SALE - Long Sleeve All Dressed Up Bodysuit_Le Macaron',
            basic_colors: '',
            trunk_sale_colors: 'Le Macaron',
        },
        {
            product_id: 7739223539774,
            product_title:
                'SALE - Long Sleeve All Dressed Up Bodysuit_Navy Shibori',
            basic_colors: '',
            trunk_sale_colors: 'Navy Shibori',
        },
        {
            product_id: 7739224326206,
            product_title: 'SALE - Long Sleeve Jack + Jill Bodysuit_Dog Tails',
            basic_colors: '',
            trunk_sale_colors: 'Dog Tails',
        },
        {
            product_id: 7739224424510,
            product_title:
                'SALE - Long Sleeve Jack + Jill Bodysuit_Navy Shibori',
            basic_colors: '',
            trunk_sale_colors: 'Navy Shibori',
        },
        {
            product_id: 7739224457278,
            product_title:
                'SALE - Long Sleeve Jack + Jill Bodysuit_Pink Winking Unicorn',
            basic_colors: '',
            trunk_sale_colors: 'Pink Winking Unicorn',
        },
        {
            product_id: 7655276478526,
            product_title: 'SALE - Adult Pom Pom Cardigan_Cream + Rainbow Dots',
            basic_colors: '',
            trunk_sale_colors: 'Cream + Rainbow Dots',
        },
        {
            product_id: 7655276609598,
            product_title: 'SALE - Knit Ear Warmer_Green',
            basic_colors: '',
            trunk_sale_colors: 'Green',
        },
        {
            product_id: 7655276576830,
            product_title: 'SALE - Knit Beret_Navy',
            basic_colors: '',
            trunk_sale_colors: 'Navy',
        },
        {
            product_id: 7655276707902,
            product_title: 'SALE - Knit Stocking Cap_Heather Grey',
            basic_colors: '',
            trunk_sale_colors: 'Heather Grey',
        },
        {
            product_id: 7655277068350,
            product_title: 'SALE - Ruffle Collar Cardigan_Green',
            basic_colors: '',
            trunk_sale_colors: 'Green',
        },
        {
            product_id: 7660433408062,
            product_title: "SALE - Bomber Jacket_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433473598,
            product_title: "SALE - Classic Bib_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433506366,
            product_title: "SALE - Coming Home Blanket_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433571902,
            product_title:
                "SALE - Embroidered Sporty Sweatsuit Set_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433604670,
            product_title:
                "SALE - Hospital Cuddle Box™  - Mini_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433670206,
            product_title: "SALE - Kimono Tie One-Piece_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433735742,
            product_title:
                "SALE - Long Sleeve Skirted Bodysuit_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433866814,
            product_title:
                'SALE - Two-Piece Pajama Set_Monsters Inc. Boo Blue Stripe',
            basic_colors: '',
            trunk_sale_colors: 'Monsters Inc. Boo Blue Stripe',
        },
        {
            product_id: 7660433801278,
            product_title: "SALE - Top Knot Cap_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
        {
            product_id: 7660433768510,
            product_title:
                "SALE - Short Sleeve Crewneck Tee_Disney's The Lion King",
            basic_colors: '',
            trunk_sale_colors: "Disney's The Lion King",
        },
    ],
}
